import styled from 'styled-components'

export const TimeSpanContainer = styled.div`
    padding: 0px 0px 12px 8px;
    margin: 0 8px;
    width: calc(100% - 8px);
    font-size: 13px;
    color: ${({ theme }) => theme['gray-800']};
    background: ${({ theme }) => theme['gray-100']};

    .react-datepicker__month-container{
        background: ${({ theme }) => theme['gray-0']};
        width:216px;
    }

    .date-pass-buttom{
        border : none;
        background: transparent;
        color: ${({ theme }) => theme['gray-800']};
    }

    

.react-datepicker__day--in-range{
    background-color:   ${({ theme }) => theme['blue-200']};
    color: ${({ theme }) => theme['gray-700']};
}

.react-datepicker__day--range-start{
    font-weight: 700;
    color: ${({ theme }) => theme['gray-800']};
}

.react-datepicker__day--range-end {
   font-weight: 700;
   color: ${({ theme }) => theme['gray-800']};
}
.react-datepicker__month{
    .react-datepicker__week{
        .react-datepicker__day--today{
    color: ${({ theme }) => theme['blue-700']} !important;
}
    }

    
}

.calendar-month-year{
    color: ${({ theme }) => theme['gray-800']};
}

.date-pass-buttom{
    font-weight: 600;
    color: ${({ theme }) => theme['blue-700']} 
}


/* .react-datepicker__day--today{
    color: ${({ theme }) => theme['blue-700']} !important;
} */

    .title {
        /* border-top: 1px solid;
        border-color: ${({ theme }) => theme['gray-300']}; */
        margin-right: 24px;
        padding: 24px 0 16px 0;
    }

    span {
        font-weight: 700;
    }

    .timespan {
        background: black;
        width: calc(100% - 16px);
        height: 250px;
    }

    .react-datepicker__navigation--next {
        color: #efefef;
        width: 16px;
        height: 10px;
        padding: 0;
        max-width: 0ch;
        overflow: hidden;
        padding-right: 5px;
        background: transparent;
    }

    .react-datepicker__navigation--previous {
        color: #efefef;
        width: 16px;
        height: 10px;
        padding: 0;
        max-width: 0ch;
        overflow: hidden;
        padding-left: 5px;
        background: transparent;
    }
    .react-datepicker__current-month {
        text-transform: capitalize;
        padding-bottom: 16px;
        font-size: 16px;
        font-weight: 600;
    }
    .react-datepicker__header {
        background: transparent;
        border: none;
    }
    .react-datepicker {
        border: none;
        background: transparent;
    }

    .react-datepicker__day,
    .react-datepicker__day-name {
        color: ${({ theme }) => theme['gray-700']} !important;
    }

    .react-datepicker__current-month {
        color: ${({ theme }) => theme['gray-800']} !important;
    }

    .react-datepicker__day--outside-month {
        color: ${({ theme }) => theme['gray-500']} !important;
    }

    .react-datepicker__day:hover {
        background-color: ${({ theme }) => theme['gray-300']} !important;
        color: ${({ theme }) => theme['gray-900']} !important;
    }

    .react-datepicker__day--selected {
        background-color: ${({ theme }) => theme['blue-300']} !important;
        color: ${({ theme }) => theme['gray-900']} !important;
        font-weight: 600;
    }
    .hours-row{
        display: flex;
        gap: 2px;

        input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Works for Firefox */
      input[type="number"] {
        -moz-appearance: textfield;
      }
    }
    
`

export const TimeInput = styled.div`
    /* margin-top: 12px; */
    width: 224px;
    height: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 0 0 0;

    .start-control {
        width: 88px;

        span {
            font-size: 13px;
            font-weight: 600;
        }

        .input {
            border: none;
            height: 28px;
            margin-top: 4px;
            background: transparent;
            padding: 0;
            border: 1px solid;
            border-radius: 3px;
            border-color: ${({ theme }) => theme['gray-400']};
            text-align: center;
        }
    }

    .space {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 14px;

        .line {
            width: 1px;
            height: 30px;
            background: ${({ theme }) => theme['gray-300']};
        }
    }
`

export const TimeSelectList = styled.div`
    padding: 18px 0 0;
    display: flex;

    .timeControl {
        width: 95px;
        height: 116px;
    }

    .timeControl + .timeControl {
        margin-left: 34px;
    }

    button {
        background: transparent;
        border: none;
        font-size: 12px;
        font-weight: 600;
        color: ${({ theme }) => theme['gray-600']};
        padding: 4px 0px;
        width: 100%;
        text-align: left;
    }
`
export const SaveBar = styled.div`
    padding: 16px;
    border-top: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
`

export const SaveButton = styled.button`
    border: 1px solid;
    border-color: ${({ theme }) => theme['blue-500']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-0']};
    background: ${({ theme }) => theme['blue-500']};
    padding: 4px 16px;
    &.disabled {
        background: ${({ theme }) => theme['blue-400']};
        border-color: ${({ theme }) => theme['blue-400']};
    }
`

export const CancelButton = styled.button`
    text-transform: capitalize;
    border: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-800']};
    background: transparent;
    margin-left: 8px;
    padding: 4px 16px;
`
